import React from 'react';
import DatePicker from 'react-datepicker';
import { useParams, useNavigate } from 'react-router-dom';
import { useBulletinDateListQuery } from '../../services/api';
import './BulletinDatePicker.scss';
import { useBulletin } from '../../context/bulletin';

const BulletinDatePicker = () => {
  const { reportId, variableId = reportId } = useParams();
  const navigate = useNavigate();

  const {
    isLatestBulletin,
    bulletinDate,
    bulletinDefaultDate,
    bulletinType,
    bulletinResponse,
  } = useBulletin();

  const endDate = bulletinResponse?.bulletin.last_update ?? bulletinDate;

  const { data: includeDates } = useBulletinDateListQuery(bulletinType ?? '');

  const handleChange = (nextDate: Date) => {
    const code = reportId ? 'r' : 'v';
    const formatedDate = nextDate.toISOString().split('T')[0];
    if (!variableId) {
      navigate(`/bulletin/${bulletinType}/${formatedDate}`);
      return;
    }
    navigate(`/bulletin/${bulletinType}/${formatedDate}/${code}/${variableId}`);
  };
  if (!endDate || !bulletinDate || !bulletinDefaultDate) {
    return null;
  }
  return (
    <div className="bulletinDatePicker">
      <label htmlFor="bulletinDateInput" className="bulletinDatePicker-label">
        Change the bulletin date
      </label>
      <DatePicker
        id="bulletinDateInput"
        className="date-picker bulletinDatePicker-input"
        selected={new Date(bulletinDate)}
        dateFormat="yyyy/MM/dd"
        selectsStart
        showMonthDropdown
        showYearDropdown
        maxDate={new Date(endDate.replace(' at ', ' '))}
        dropdownMode="select"
        onChange={handleChange}
        popperPlacement="bottom"
        includeDates={includeDates}
      >
        {!isLatestBulletin && (
          <div>
            <button
              type="button"
              className="Button-begin-end"
              onClick={() => handleChange(new Date(bulletinDefaultDate))}
            >
              Go to latest bulletin
            </button>
          </div>
        )}
      </DatePicker>
    </div>
  );
};

export default BulletinDatePicker;
